// router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'

// 布局组件
import BlankLayout from '@/layout/BlankLayout.vue'
import MainLayout from '@/layout/MainLayout.vue'

// 页面组件（懒加载）
const Login = () => import('@/pages/Login.vue')

Vue.use(VueRouter)

export const menuRoutes = [
  {
    path: '/HomePage',
    name: 'HomePage',
    component: () => import('@/pages/HomePage.vue'),
    meta: { title: '首页', icon: 'sy', activeMenu: '/HomePage', hiddenSubMenu: true }
  },
  {
    path: '/UserManage',
    name: 'UserManage',
    component: () => import('@/pages/UserManage.vue'),
    meta: { title: '用户管理', icon: 'yhgl', activeMenu: '/UserManage', hiddenSubMenu: true }
  },
  {
    path: '/SqlManage',
    name: 'SqlManage',
    component: () => import('@/pages/SqlManage.vue'),
    meta: { title: '数据库管理', icon: 'sjkgl', hiddenSubMenu: true }
  },
  {
    path: '/SuggestAnswer',
    name: 'SuggestAnswer',
    component: () => import('@/pages/SuggestAnswer.vue'),
    meta: { title: '反馈意见回复', icon: 'fkyj', activeMenu: '/SuggestAnswer' }
  },
]

const routes = [
  // ========== 无侧边栏路由 ==========
  {
    path: '/login',
    component: BlankLayout,  // 空白布局
    children: [
      {
        path: '',
        name: 'Login',
        component: Login,
        meta: { title: '登录' }
      }
    ]
  },
  // ========== 带侧边栏路由 ==========
  {
    path: '/',
    component: MainLayout,   // 主布局（带侧边栏）
    redirect: '/HomePage',
    children: menuRoutes     // 复用菜单路由
  },
  {
    path: '*',
    redirect: '/login'
  }
]
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
// 路由守卫：未登录跳登录页
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  // const token = sessionStorage.getItem('token')
  // 未登录且不是登录页
  if (!token && to.path !== '/login') {
    return next('/login')
  }
  // 已登录且是登录页
  if (token && to.path === '/login') {
    return next('/')
  }
  next()
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

export default router